import { TypedApi } from "@tento-core/typed-api";
import { Network } from "@tento-web/admin/system-routes";

export const SystemApi = TypedApi.make<Network.Routes>();
